import Vue from 'vue'
import { MutationTree } from 'vuex/types/index'
import { InvitesState, InviteResource } from './invites.types'

const mutations: MutationTree<InvitesState> = {
  SET_INVITE (state, invite: InviteResource) {
    Vue.set(state.data, invite.id, invite)
  }
}

export default mutations
